import React, { useState, useLayoutEffect } from "react";
import Video from "app/(home)/Accueil.mp4";
import PageMission from "app/apropos/Mission/PageMission";
import PagePermis from "app/apropos/Permis/PagePermis";
import PageFondateur from "app/apropos/Fondateur/PageFondateur";
import PageArchiveVideo from "app/(archives)/videos/page";
import PagePhotos from "app/photos/PagePhotos";
import PageServices from "app/services/page";
import PagePrix from "app/prix/page";
import PageContact from "app/(others)/contact/page";
import ImageMapper from "react-img-mapper";
import "../../styles/styles.css";

const URL = "images/transparentBg.png";

const PageHome = () => {
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
  });

const resizeWindow = () => {
  const screenWidth = window.innerWidth;
  const videoRatio = 16 / 9;

  let width = screenWidth;
  let height = width / videoRatio;

  setDimensions({ width, height });
};


  useLayoutEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  const { width, height } = dimensions;

  const hrefs = [
    "video/vBtOfarFyMM",
    "video/jRAbLC4m3Qs",
    "video/jlzeghVXeTk",
    "video/Zi5C8BVuL9U",
    "video/7mvIDtradzE",
    "video/2GSjgjpXy7E",
    "video/uNzAOBvrv68",
    "video/-8CWMbCadRs",
    "video/DCO32QcJplk",
  ];

  const generateAreas = () => {
    const areas = [];
    const cols = 3;
    const rows = 3;
    const rectWidth = width / cols;
    const rectHeight = height / rows;

    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const x1 = Math.round(col * rectWidth);
        const y1 = Math.round(row * rectHeight);
        const x2 = Math.round((col + 1) * rectWidth);
        const y2 = Math.round((row + 1) * rectHeight);

        areas.push({
          name: `${row * cols + col + 1}`,
          shape: "poly",
          coords: [x1, y1, x2, y1, x2, y2, x1, y2],
          fillColor: "rgba(255,255,255,0.3)",
          href: hrefs[row * cols + col],
        });
      }
    }
    return areas;
  };

  const MAP = { name: "my-map", areas: generateAreas() };

  return (
    <>
      <div className="fullScreen">
        <div className="parent">
          <div className="overlay">
            {width > 0 && height > 0 && (
              <ImageMapper
                src={URL}
                map={MAP}
                width={width}
                height={height}
                strokeColor="white"
                lineWidth={5}
              />
            )}
          </div>

          <video
            autoPlay
            loop
            muted
            className="center bg-vid"
            width={width}
            height={height}
          >
            <source src={Video} type="video/mp4" />
          </video>
        </div>
      </div>

      <PageMission />
      <PageServices />
      <PageArchiveVideo />
      <PagePhotos />
      <PagePrix />
      <PagePermis />
      <PageFondateur />
      <PageContact />
    </>
  );
};

export default PageHome;
